import { CoreDataSecurityApplicationsName } from './name';
import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityApplicationsSlice } from './get';
import { PatchDataSecurityApplicationByIdRequest } from '@api/data-security';

export const removeCoreDataSecurityApplicationSyncSlice = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: CoreDataSecurityApplicationsName,
	state: getCoreDataSecurityApplicationsSlice.asyncState,
	target: (request: PatchDataSecurityApplicationByIdRequest) => (app) =>	app.applicationId === request.applicationId
});
